import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { store, persistor } from "./store";
import { PersistGate } from "redux-persist/integration/react";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { GoogleOAuthProvider } from "@react-oauth/google";

// Prevent third-party browser extension errors (e.g. Urban VPN chrome-extension://.../200.js) from crashing the React error overlay
if (typeof window !== "undefined") {
  const isExtensionError = (errorEvent) => {
    const filename = errorEvent?.filename || "";
    const message = errorEvent?.message || "";
    const stack = errorEvent?.error?.stack || "";
    return (
      filename.includes("chrome-extension://") ||
      filename.includes("moz-extension://") ||
      filename.includes("safari-extension://") ||
      stack.includes("chrome-extension://") ||
      stack.includes("moz-extension://") ||
      stack.includes("eppiocemhmnlbhjplcgkofciiegomcon") ||
      message.includes("reading 'M_ID'") ||
      message.includes("Cannot read properties of undefined (reading 'M_ID')")
    );
  };

  window.addEventListener(
    "error",
    (event) => {
      if (isExtensionError(event)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return true;
      }
    },
    true,
  );

  window.addEventListener(
    "unhandledrejection",
    (event) => {
      const reason = event?.reason;
      const stack = reason?.stack || "";
      const message = reason?.message || String(reason || "");
      if (
        stack.includes("chrome-extension://") ||
        stack.includes("eppiocemhmnlbhjplcgkofciiegomcon") ||
        message.includes("reading 'M_ID'")
      ) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true,
  );
}

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
    <Provider store={store}>
      <PersistGate
        loading={null}
        persistor={persistor}
      >
        <App />
      </PersistGate>
    </Provider>
  </GoogleOAuthProvider>,
);

if (process.env.NODE_ENV === "production") {
  serviceWorkerRegistration.register();
} else {
  serviceWorkerRegistration.unregister();
}
